import React, {Fragment} from "react";

import {Button} from "@pg-design/button-module";
import {w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";

import {getLeadButtonText} from "../../../lead/utils/get_lead_button_text";

interface IProps {
    twoPercentCreditAvailable?: boolean;
    onClick?: (event: React.MouseEvent) => void;
    variant?: "tile";
    isPlansList?: boolean;
    isInPropertyConfigurator?: boolean;
    showPrice?: boolean;
    price?: number | null;
    priceType?: number | null;
    currency: string;
}

export const AskForPropertyButton: React.FC<IProps> = (props) => {
    const onClick = (event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        props.onClick && props.onClick(event);
    };

    const buttonText = getLeadButtonText({
        isPriceHidden: !props.showPrice,
        isProperty: true,
        propertyPrice: props.price,
        priceType: props.priceType,
        currency: props.currency,
        showPropertyExactPrice: !!props.price && props.showPrice && !props.isPlansList,
        isPropertyList: true
    });

    return (
        <Fragment>
            {/* Due to CU-8693ecg7r temporary commented - program "Kredyt 2%" has ended at the begging of 2024 */}
            {/*{props.twoPercentCreditAvailable && !props.isPlansList && (*/}
            {/*    <div css={[flexAbsoluteCenter, mb(0.5)]}>*/}
            {/*        <MegaphoneIcon css={mr()} size="2" /> <Text variant="info_txt_1">Kredyt 2%</Text>*/}
            {/*    </div>*/}
            {/*)}*/}

            {props.isPlansList || props.isInPropertyConfigurator ? (
                <Button dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OPEN_LEAD_FORM_PROPERTY_BOX} variant="filled_primary" size="x-small" onClick={onClick} css={w100}>
                    <Text variant="button_small">{buttonText}</Text>
                </Button>
            ) : (
                <Button dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OPEN_LEAD_FORM_PROPERTY_BOX} onClick={onClick} variant="highlight_primary">
                    {buttonText}
                </Button>
            )}
        </Fragment>
    );
};
import React, {Fragment} from "react";

import {Button} from "@pg-design/button-module";
import {w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";

import {getLeadButtonText} from "../../../lead/utils/get_lead_button_text";

interface IProps {
    twoPercentCreditAvailable?: boolean;
    onClick?: (event: React.MouseEvent) => void;
    variant?: "tile";
    isPlansList?: boolean;
    isInPropertyConfigurator?: boolean;
    showPrice?: boolean;
    price?: number | null;
    priceType?: number | null;
    currency: string;
}

export const AskForPropertyButton: React.FC<IProps> = (props) => {
    const onClick = (event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        props.onClick && props.onClick(event);
    };

    const buttonText = getLeadButtonText({
        isPriceHidden: !props.showPrice,
        isProperty: true,
        propertyPrice: props.price,
        priceType: props.priceType,
        currency: props.currency,
        showPropertyExactPrice: !!props.price && props.showPrice && !props.isPlansList,
        isPropertyList: true
    });

    return (
        <Fragment>
            {/* Due to CU-8693ecg7r temporary commented - program "Kredyt 2%" has ended at the begging of 2024 */}
            {/*{props.twoPercentCreditAvailable && !props.isPlansList && (*/}
            {/*    <div css={[flexAbsoluteCenter, mb(0.5)]}>*/}
            {/*        <MegaphoneIcon css={mr()} size="2" /> <Text variant="info_txt_1">Kredyt 2%</Text>*/}
            {/*    </div>*/}
            {/*)}*/}

            {props.isPlansList || props.isInPropertyConfigurator ? (
                <Button dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OPEN_LEAD_FORM_PROPERTY_BOX} variant="filled_primary" size="x-small" onClick={onClick} css={w100}>
                    <Text variant="button_small">{buttonText}</Text>
                </Button>
            ) : (
                <Button dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OPEN_LEAD_FORM_PROPERTY_BOX} onClick={onClick} variant="highlight_primary">
                    {buttonText}
                </Button>
            )}
        </Fragment>
    );
};
